import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  headline: {
    fontFamily: 'Roboto Condensed',
    fontSize: theme.typography.h5.fontSize,
    fontWeight: theme.typography.fontWeightLight,
  },

  list: {
    margin: theme.spacing(6, 0),
  },

  bullet: {
    margin: theme.spacing(2, 0),
  },

  bulletText: {
    fontWeight: theme.typography.fontWeightRegular,
  },

  icon: {
    fontSize: theme.typography.h5.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.extras.green,
  },

  iconWrapper: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      justifyContent: 'flex-end',
      paddingRight: theme.spacing(1),
    },
  },
}))
